<!-- eslint-disable max-lines -->
<template>
  <div :class="['widget', {'border-error': error}]">
    <v-container>
      <v-layout>
        <span class="subheading">Contacts</span>
      </v-layout>

      <template v-if="loading">
        <v-layout
          align-center
          justify-center
          fill-height>
          <v-progress-circular
            size="50"
            indeterminate/>
        </v-layout>
      </template>

      <template v-else>
        <v-container style="padding: 12px 24px 0 24px;">
          <div
            v-for="(contact, index) in contacts"
            :key="contact.name">
            <v-layout
              align-center
              justify-space-between>
              <v-flex grow>
                <span class="body-2">{{ contact.name }}</span>
              </v-flex>
              <v-flex shrink>
                <v-btn
                  v-if="expand[index]"
                  class="ma-0"
                  icon
                  @click="expand.splice(index, 1, false)">
                  <v-icon>expand_less</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  class="ma-0"
                  icon
                  @click="expand.splice(index, 1, true)">
                  <v-icon>expand_more</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-expansion-panel
                :value="expand[index] ? 0 : -1"
                style="box-shadow: none;">
                <v-expansion-panel-content
                  style="background-color: initial;
                         padding-left: 20px;">
                  <table
                    class="mb-1"
                    style="width: 100%; table-layout: fixed;">
                    <tr>
                      <td class="body-2 grey--text">Description</td>
                      <td colspan="2">{{ contact.description }}</td>
                    </tr>
                    <tr>
                      <td class="body-2 grey--text">Email</td>
                      <td colspan="2">{{ contact.email }}</td>
                    </tr>
                    <tr>
                      <td class="body-2 grey--text">Phone</td>
                      <td colspan="2">{{ contact.phoneNumber }}</td>
                    </tr>
                    <tr>
                      <td class="body-2 grey--text">Mobile</td>
                      <td colspan="2">{{ contact.mobilePhoneNumber }}</td>
                    </tr>
                    <tr>
                      <td class="body-2 grey--text">Address</td>
                      <td colspan="2">{{ contact.address }}</td>
                    </tr>
                  </table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-layout>
            <v-divider/>
          </div>
        </v-container>
      </template>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "contacts",
  data () {
    return {
      contacts: [],
      error: false,
      expand: [],
      loading: false
    };
  },
  created () {
    this.loading = true;
    this.$http.
      get(`/api/sites/${this.$route.params.id}/contacts`).
      then((r) => {
        this.expand = r.data.map(() => false);
        this.contacts = r.data;
      }).
      catch(() => this.error = true).
      finally(() => this.loading = false);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Site/Contacts.vue